<template>
	<div class="bookmarks-actions-container" v-if="this.$route.name === 'bookmarks' ">
		<div class="filter-group">
			<select class="category-select" v-model="filteredBy">
				<option value="">{{ $t('sorting.displayAll') }}</option>
				<option value="companies">{{ $t('companyList.destinations') }}</option>
				<option value="salespoints">{{ $t('companyList.salespoints') }}</option>
			</select>
		</div>

		<div class="card-button-wrapper">
			<router-link class="button btn-map hollow" :to="{ name: 'map' }">
				<font-awesome-icon :icon="['fal', 'map']" />
				Karte
			</router-link>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'BookmarksActions',
		data () {
			return {
				filteredBy: ''
			}
		},
		watch: {
			filteredBy: function (value) {
				this.$eBus.$emit('update-bookmarks-entity-filter', value)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bookmarks-actions-container{
		@include xy-grid();
		@include xy-gutters($gutter-type: padding, $gutter-position: left right bottom);
		max-width: rem-calc(600);
		margin: 0 auto;
		margin-top: 1rem;

		.filter-group{
			@include xy-cell(6);
			margin-left: 0;
			margin-right: auto;

			.category-select{
				margin: 0;
				padding: .5rem 1rem;
				padding-right: 2rem;
				color: $dark-gray;
				border-radius: 20rem;
				align-items: flex-end;
			}
		}

		.card-button-wrapper{
			@include xy-cell(6);
			margin-left: auto;
			margin-right: 0;
			display: flex;
			justify-content: center;
			align-items: center;

			.btn-map{
				display: inline-block;
				width: 100%;
				margin-bottom: 0;
				border-radius: 20rem;
			}
		}

		.filter-wrapper{
			// @include xy-cell(1, false, 0);
			display: flex;
			display: none;
			align-items: center;
			justify-content: flex-end;

			.btn-filter{
				margin: 0;
				color: $dark-gray;
				border: 1px solid $dark-gray;
				border-radius: 20rem;

				&:hover,
				&:focus {
					color: scale-color($dark-gray, $lightness: -15%);
					border: 1px solid scale-color($dark-gray, $lightness: -15%);
				}
			}
		}
	}
</style>